import './chart_view.js.coffee';# Added by Script 
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.TicketCountChartView extends CustomerVisualMode.Charts.ChartView
  template: JST['backbone/templates/customer_visual_mode/charts/ticket_count/ticket_count_chart']
  className: 'grid-item full-width-chart'
  @NAME: 'ticket_count'

  initialize: ({widget, data, session, isReadOnly, isResponsive, title, description}) ->
    title ||= I18n.t('customer_visual_mode.charts.ticket_count.title')
    description ||= I18n.t('customer_visual_mode.charts.ticket_count.description')
    super({widget, title, description, data, session, isReadOnly, isResponsive})

  render: ->
    super()
    @$el.find('.chart').html @template
    @_ticketCountCardViews().forEach (view) =>
      @$('.ticket-count-chart').append(
        view.render().el
      )
      @listenTo(view, 'ticketCountCard:click', @_openDrilldown)
    @

  _ticketCountCardViews: ->
    [
      @_newTicketsView()
      @_pendingAttentionTicketsView()
      @_inAttentionTicketsView()
      @_waitingForAnAnswerTicketsView()
      @_closedTicketsView()
    ]

  _newTicketsView: ->
    @newTicketsView ||= new CustomerVisualMode.Charts.TicketCountCardView(
      id: 'new_tickets'
      count: @_newTicketCount()
      statusClass: 'new-tickets'
      iconClass: 'fa fa-plus-circle'
      clickable: not @isReadOnly
      title: I18n.t('customer_visual_mode.charts.ticket_count.new')
    )

  _pendingAttentionTicketsView: ->
    @pendingAttentionTicketsView ||= new CustomerVisualMode.Charts.PendingTicketsView(
      count: @data.pending_attention_ticket_count
      clickable: not @isReadOnly
    )

  _inAttentionTicketsView: ->
    @inAttentionTicketsView ||= new CustomerVisualMode.Charts.InAttentionTicketsView(
      count: @data.in_attention_ticket_count
      clickable: not @isReadOnly
    )

  _waitingForAnAnswerTicketsView: ->
    @waitingForAnAnswerTicketsView ||= new CustomerVisualMode.Charts.TicketCountCardView(
      id: 'waiting_for_answer_tickets'
      count: @data.waiting_for_an_answer_ticket_count
      statusClass: 'waiting-for-answer-tickets'
      iconClass: 'fa fa-clock-o'
      clickable: not @isReadOnly
      title: I18n.t('customer_visual_mode.charts.ticket_count.waiting_for_answer')
    )

  _closedTicketsView: ->
    @closedTicketsView ||= new CustomerVisualMode.Charts.TicketCountCardView(
      id: 'closed_tickets'
      count: @data.closed_ticket_count
      statusClass: 'closed-tickets'
      iconClass: 'fa fa-check-circle'
      clickable: not @isReadOnly
      title: I18n.t('customer_visual_mode.charts.ticket_count.closed')
    )

  _newTicketCount: ->
    @data.closed_ticket_count +
    @data.in_attention_ticket_count +
    @data.pending_attention_ticket_count +
    @data.waiting_for_an_answer_ticket_count

  _openDrilldown: (id) ->
    value = @_drilldownValues()[id]
    data = {
      dimensions: ['ticket_status'],
      values: value.values,
      name: value.name,
      definition_code: null,
      drilldown_code: 'created_conversations',
      timezone: moment().format('Z')
    }
    super(data)

  _drilldownValues: ->
    {
      new_tickets: {
        name: 'New tickets',
        values: ['Assigned', 'Not Assigned', 'Pending', 'Reopen', 'Closed']
      },
      pending_tickets: {
        name: 'Pending tickets',
        values: ['Not Assigned'],
      },
      in_attention_tickets: {
        name: 'In attention tickets',
        values: ['Assigned'],
      },
      waiting_for_answer_tickets: {
        name: 'Waiting for answer tickets',
        values: ['Pending', 'Reopen'],
      },
      closed_tickets: {
        name: 'Closed tickets',
        values: ['Closed'],
      }
    }
